import { Column, CurrencyType, Row, useFormatCurrency } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { RegistrationShopSummaryResource, ShopSummaryTaxResource } from "../../../shared/types";
import { Subheading } from "./ShopSummaryComponents";

interface Props {
	currencyType: CurrencyType;
	prices: RegistrationShopSummaryResource;
	totalTaxes: ShopSummaryTaxResource[];
}

export function TotalRefunds({ currencyType, totalTaxes, prices: { toBeRefundedAmount } }: Props) {
	const { t } = useTranslation();
	const formatCurrency = useFormatCurrency(currencyType);

	return (
		<Column $gap={0}>
			<Row $justifyContent="space-between">
				<Subheading>{t("To be refunded:")}</Subheading>
				<Subheading>{formatCurrency(toBeRefundedAmount)}</Subheading>
			</Row>
			{totalTaxes.map((tax) => (
				<TaxRow key={tax.percent} tax={tax} currencyType={currencyType} />
			))}
		</Column>
	);
}

type TaxRowProps = {
	tax: ShopSummaryTaxResource;
	currencyType: CurrencyType;
};

const TaxRow: FC<TaxRowProps> = ({ tax, currencyType }) => {
	const { t } = useTranslation();
	const formatCurrency = useFormatCurrency(currencyType);

	return (
		<Row $justifyContent="space-between">
			<span>{t("incl. {{percent}}% VAT:", { percent: tax.percent })}</span>
			<span>{formatCurrency(tax.amount)}</span>
		</Row>
	);
};
